"use strict";
/**
 * This a constructor (class) for credit card number input
 * @param {Object} node dom node
 * @constructor
 * @extends spiral.BaseDOMConstructor
 */
spiral.CardNumber = function (node) {
    this.init(node);//call parent

    this.els = {//elements
        node: node,
        input: node.getElementsByClassName("form-control")[0],
        hidden: node.querySelectorAll("input[type='hidden']")[0]
    };

    this.addEventListeners();
    //if (this.els.input.value.length) {
    //    this.inputHandler();
    //}
};

/**
 * Inherit from base.
 * @type {spiral.BaseDOMConstructor.prototype}
 * @lends spiral.CardNumber.prototype
 */
spiral.CardNumber.prototype = Object.create(spiral.BaseDOMConstructor.prototype);

/**
 * Rules to detect card types
 * @type {{Visa: string[], MasterCard: string[], Amex: string[], Discover: string[], Maestro: string[], Solo: string[], Diners: string[], JCB: string[]}}
 */
spiral.CardNumber.prototype.rules = {
    "Visa": ["4"],
    "MasterCard": ["51", "52", "53", "54", "55"],
    "Amex": ["34", "37"],
    "Discover": ["6011", "65"],
    "Maestro": ["5018", "5020", "5038", "6304", "6759", "6761", "6763"],
    "Solo": ["6334", "6767"],
    "Diners": ['300', '301', '302', '303', '304', '305', '36'],
    "JCB": ['3528', '3529', '353', '354', '355', '356', '357', '358']
};

/**
 * Check card type from number by rules
 * @param {string|number} n
 */
spiral.CardNumber.prototype.checkType = function (n) {
    if (typeof n === 'number') n = n.toString();
    for (var r in this.rules) {
        if (this.rules.hasOwnProperty(r)) {
            if (this.rules[r].some(function (subrule) {
                    return subrule == n.substring(0, subrule.length);
                })) {
                return r;
            }
        }
    }
    return '';
};

/**
 * Handling of input event
 */
spiral.CardNumber.prototype.inputHandler = function () {

    var result, ar = [], stopNonDigitString, stopNonDigitLength, position,
        start = this.els.input.selectionStart,
        v = this.els.input.value,
        startNonDigitString = v.substring(0, start).match(/\D/g),
        startNonDigitLength = (startNonDigitString) ? startNonDigitString.length : 0;
    v = v.replace(/\D/g, '');
    this.type = this.checkType(v);
    this.setType();

    // formatting input
    if (this.type == "Amex") {
        ar[0] = v.substring(0, 4);
        if (v.length > 4) ar[1] = v.substring(4, 10);
        if (v.length > 10) ar[2] = v.substring(10, 15);
    } else if (this.type == "MasterCard" || this.type == "Visa") {
        ar[0] = v.substring(0, 4);
        if (v.length > 4) ar[1] = v.substring(4, 8);
        if (v.length > 8) ar[2] = v.substring(8, 12);
        if (v.length > 12) ar[3] = v.substring(12, 16);
    } else {
        ar[0] = v.substring(0, 4);
        if (v.length > 4) ar[1] = v.substring(4, 8);
        if (v.length > 8) ar[2] = v.substring(8, 12);
        if (v.length > 12) ar[3] = v.substring(12, 16);
        if (v.length > 16) ar[4] = v.substring(16, 19);
    }

    result = ar ? ar.join(' ') : '';
    this.els.hidden.value = ar ? ar.join('') : '';
    this.els.input.value = result;



    // calculating position where is caret need to be placed.

    if (!result) return; //if there's no value, no need to position the caret
    stopNonDigitString = result.substring(0, start).match(/\D/g);
    stopNonDigitLength = (stopNonDigitString) ? stopNonDigitString.length : 0;
    position = start + stopNonDigitLength - startNonDigitLength;
    this.els.input.setSelectionRange(position, position);
};

/**
 * Adds events listeners.
 */
spiral.CardNumber.prototype.addEventListeners = function () {
    this.els.input.addEventListener("input", this.inputHandler.bind(this));
    if (this.els.input.form) {
        this.els.input.form.addEventListener("reset", this.reset.bind(this))
    }
};

/**
 * Set data-cardtype for styling
 */
spiral.CardNumber.prototype.setType = function () {
    if (this.els.input.dataset) {
        this.els.input.dataset.cardtype = this.type;
    } else {//ie9-
        this.els.input.setAttribute('cardtype', this.type);
    }
};

/**
 * Reset cardNumber's type and value.
 */
spiral.CardNumber.prototype.reset = function () {
    if (this.els.input.dataset) {
        this.els.input.dataset.cardtype = '';
    } else {//ie9-
        this.els.input.removeAttribute('cardtype');
    }
    this.els.hidden.value = "";
};

/**
 * Kill events' listeners
 */
spiral.CardNumber.prototype.die = function () {
    this.els.input.removeEventListener("input", this.inputHandler);
    if (this.els.input.form) {
        this.els.input.form.removeEventListener("reset", this.reset)
    }
};

spiral.instancesController.addInstanceType("CardNumber", "js-spiral-cardnumber", spiral.CardNumber);